module.exports = __webpack_public_path__ + "static/media/Voyage soffa 4-sits cozy grön detalj 2024 7.4b9ec177.jpg";